module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_bengali.c2d18b1b.mp3";